function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Formik, Field, ErrorMessage } from "formik";
import Select from "react-select";
import PropTypes from "prop-types";
import defaultPropTypes from "../utils/prop-types";
import { getRecaptchApiKey } from "./../utils/implementRecaptchaTestScript";
import HclLoader from "./../utils/HclLoader";
import { trackHCLFormSubmit, trackFormSubmit } from "../../../../../js/project/tracking-gtm-ga4";
var SelectField = function SelectField(_ref) {
  var options = _ref.options,
    field = _ref.field,
    form = _ref.form;
  var customStyles = {
    singleValue: function singleValue(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        overflow: "visible"
      });
    },
    control: function control(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        borderColor: "#B7B3AC",
        "&:hover": {
          borderColor: "#c6168d"
        },
        boxShadow: "none",
        marginBottom: "0.5rem",
        borderRadius: state.menuIsOpen ? "3px 3px 0 0" : "3px",
        padding: "0.3rem",
        fontSize: "1rem"
      });
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        // eslint-disable-next-line no-nested-ternary
        backgroundColor: state.isSelected ? "#6B6867" : state.isFocused ? "#F7F6F4" : "none",
        // eslint-disable-next-line no-nested-ternary
        color: state.isSelected ? "white" : "inherit",
        padding: "1rem",
        "&:not(:last-child)": {
          borderBottom: "1px solid #B7B3AC"
        },
        "&:last-child": {
          borderRadius: "0 0 3px 3px"
        }
      });
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: "#c6168d",
        padding: "0.4rem 0.4rem 0.4rem 0.6rem"
      });
    },
    indicatorSeparator: function indicatorSeparator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        backgroundColor: "#D7D3CC",
        marginBottom: "-0.3rem",
        marginTop: "-0.3rem"
      });
    },
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        marginTop: 0,
        border: "1px solid #B7B3AC",
        borderTop: 0,
        boxShadow: "none",
        borderRadius: "0 0 3px 3px",
        boxSizing: "border-box"
      });
    },
    menuList: function menuList(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: 0,
        margin: 0
      });
    }
  };
  return /*#__PURE__*/React.createElement(Select, {
    options: options,
    value: options ? options.find(function (option) {
      return option.value === field.value;
    }) : "",
    placeholder: field.placeholder,
    isClearable: false,
    isSearchable: false,
    onChange: function onChange(option) {
      return form.setFieldValue(field.name, option.value);
    },
    className: "location-detail-form__input location-detail-form__input--select",
    styles: customStyles
  });
};
SelectField.propTypes = {
  options: PropTypes.arrayOf(defaultPropTypes.formSelectOption).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  field: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.any.isRequired
};
var CheckBox = function CheckBox(props) {
  return /*#__PURE__*/React.createElement(Field, {
    name: props.name
  }, function (_ref2) {
    var field = _ref2.field,
      form = _ref2.form;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
      type: "checkbox"
    }, props, {
      /* Because we get a string and not a boolean from the backend,
      we convert it to a boolean. If there is ANYTHING in the string
      (even 'false') it will resolve to true. So value should be empty
      for false (ie. checkbox not checked initially) */
      checked: !!field.value,
      onChange: function onChange() {
        form.setFieldValue(field.name, !field.value);
      }
    })), /*#__PURE__*/React.createElement("label", {
      dangerouslySetInnerHTML: {
        __html: props.label
      },
      htmlFor: props.id
    }));
  });
};
CheckBox.propTypes = {
  name: defaultPropTypes.string.isRequired,
  label: defaultPropTypes.string.isRequired,
  id: defaultPropTypes.string.isRequired
};
var OticonLocationDetailForm = function OticonLocationDetailForm(props) {
  var _window;
  // Add honeypot
  var isExternal = document.querySelector(".hcl-embed-form");
  var isRecaptcha = (_window = window) === null || _window === void 0 ? void 0 : _window.grecaptcha;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    widgetId = _useState2[0],
    setWidgetId = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    isRecaptchaValidated = _useState4[0],
    setRecaptchaValidated = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    formData = _useState6[0],
    setFormData = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    formPending = _useState8[0],
    setFormPending = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    captchaRequiredError = _useState0[0],
    setcaptchaRequiredError = _useState0[1];
  if (props.Fields.length && props.Fields[props.Fields.length - 1].Name !== "location-info-issue") {
    props.Fields.push({
      Name: "location-info-issue",
      Type: "text",
      Value: "",
      Label: "Location detail issue",
      Placeholder: "Please provide info",
      Required: false,
      Pattern: "",
      ErrorMessage: {
        Required: "Please provide info",
        Pattern: ""
      },
      Options: [],
      CrmFieldId: "twain"
    });
  }
  var initialValues = props.Fields.reduce(function (acc, field) {
    acc[field.Name] = field.Value;
    return acc;
  }, {});
  var validate = function validate(values) {
    var errors = {};
    var keys = Object.keys(values);
    keys.forEach(function (key) {
      var _props$Fields$find = props.Fields.find(function (field) {
          return field.Name === key;
        }),
        required = _props$Fields$find.Required,
        pattern = _props$Fields$find.Pattern,
        errorMessage = _props$Fields$find.ErrorMessage;
      if (required && !values[key]) {
        errors[key] = errorMessage.Required;
      } else if (pattern) {
        var regex = new RegExp(pattern);
        if (!regex.test(values[key])) {
          errors[key] = errorMessage.Pattern;
        }
      }
    });
    return errors;
  };
  var handleFocusSingleLine = function handleFocusSingleLine(id) {
    document.getElementById("single-line-label-".concat(id)).classList.add("location-detail-form__label--focus");
  };
  var findEnquiryReason = function findEnquiryReason(valuesArr) {
    var enquiryReason = "";
    Object.keys(valuesArr).map(function (key) {
      if (key === "enquiryreason" || key === "nature of enquiry") {
        enquiryReason = valuesArr[key];
      }
    });
    window.DGS.Event.getInstance().trigger("submitFormLocationsClinicClick", props.clinicShortName, enquiryReason);
  };
  var triggerSubmit = function triggerSubmit(values, _ref3) {
    var setSubmitting = _ref3.setSubmitting;
    if (isRecaptcha) {
      var isCaptchaChecked = !!document.querySelector(".recaptcha-checkbox-checked");
      if (!isCaptchaChecked) {
        setcaptchaRequiredError(true);
      }
      setFormData({
        values: values,
        setSubmitting: setSubmitting
      });
      grecaptcha.execute(getRecaptchApiKey() || "", {
        action: "submit"
      }).then(function () {
        grecaptcha.getResponse(widgetId);
      });
    } else {
      onSubmit(values, {
        setSubmitting: setSubmitting
      });
    }
  };
  var isFormDisabled = function isFormDisabled(formikProps) {
    if (formikProps) {
      var _Object$keys;
      return !Boolean(formikProps.isValid && ((_Object$keys = Object.keys(formikProps.touched)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length));
    }
  };
  var onSubmit = function onSubmit(values, _ref4) {
    var setSubmitting = _ref4.setSubmitting;
    // Honeypot. Don't submit if filled out
    setcaptchaRequiredError(false);
    if (values["location-info-issue"] !== "") {
      setSubmitting(false);
      return;
    }
    delete values["location-info-issue"];
    // Create the payload
    var payload = {};
    payload.fields = Object.keys(values).map(function (key) {
      return {
        name: key,
        value: values[key]
      };
    });
    findEnquiryReason(values);
    setFormPending(true);
    payload.id = props.configurationId;
    payload.clinic = props.clinicDetails;
    payload.clinicId = props.clinicId;
    payload.clinicemail = props.clinicEmail;
    payload.clinicname = props === null || props === void 0 ? void 0 : props.clinicName;
    payload.cliniccity = props === null || props === void 0 ? void 0 : props.clinicCity;
    payload.clinicaddress = props === null || props === void 0 ? void 0 : props.clinicAddress;
    payload.clinicphone = props === null || props === void 0 ? void 0 : props.clinicPhone;
    // call onFormWillSubmit callback with payload
    props.onFormWillSubmit(payload);
    // create the endpoint url
    var endPoint = "".concat(props.SubmitEndPoint);
    axios.post(endPoint, payload).then(function (response) {
      setFormPending(false);
      // Endpoint always responds with status code 200, so we have to
      // check for errors by checking that the `ErrorMessages` array in the
      // response is empty
      if (response.data && response.data.ErrorMessages && response.data.ErrorMessages.length > 0) {
        return props.onFormSubmitError(response.data.ErrorMessages[0].Value);
      }
      // call submitSuccess callback on props
      return props.onFormSubmitSuccess();
    }).catch(function (error) {
      setFormPending(false);
      props.onFormSubmitError(error);
    }).finally(function () {
      setFormPending(false);
      setSubmitting(false);
      trackHCLFormSubmit(payload.clinicname, payload.clinicId);
      trackFormSubmit();
    });
  };
  useEffect(function () {
    if (isRecaptchaValidated && formData) {
      setcaptchaRequiredError(false);
      onSubmit(formData.values, formData);
    }
  }, [isRecaptchaValidated, setRecaptchaValidated, formData, setFormData, onSubmit]);
  useEffect(function () {
    if (isRecaptcha) {
      grecaptcha.ready(function () {
        var _grecaptcha;
        var widgetElement = (_grecaptcha = grecaptcha) === null || _grecaptcha === void 0 ? void 0 : _grecaptcha.render("captcha-container", {
          sitekey: getRecaptchApiKey(),
          callback: function callback(response) {
            response.length > 0 ? setRecaptchaValidated(true) : console.log("recaptcha error");
          }
        });
        setWidgetId(widgetElement);
      });
    }
    return function () {
      setWidgetId(null);
    };
  }, [isRecaptcha, setWidgetId, setRecaptchaValidated]);
  return /*#__PURE__*/React.createElement("div", {
    className: "location-detail-form"
  }, formPending && /*#__PURE__*/React.createElement(HclLoader, null), /*#__PURE__*/React.createElement("h5", {
    className: "location-detail-form__heading"
  }, props.FormTitle), isExternal ? /*#__PURE__*/React.createElement(EmbedForm, {
    clinicDetails: props.clinicDetails,
    clinicEmail: props.clinicEmail
  }) : /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: triggerSubmit,
    render: function render(formikProps) {
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: formikProps.handleSubmit,
        className: "location-detail-form__form"
      }, props.Fields.map(function (field) {
        if (field.Type === "select") {
          // convert keys to lowercase
          var options = field.Options.map(function (option) {
            return {
              value: option.Value,
              label: option.Label
            };
          });
          return /*#__PURE__*/React.createElement("div", {
            key: field.Name,
            className: "location-detail-form__row"
          }, /*#__PURE__*/React.createElement(Field, {
            name: field.Name,
            component: SelectField,
            options: options,
            placeholder: field.Placeholder,
            "aria-labelledby": "label-".concat(field.Name)
          }), /*#__PURE__*/React.createElement("div", {
            className: "location-detail-form__field-info"
          }, field.Label && /*#__PURE__*/React.createElement("div", {
            id: "label-".concat(field.Name)
          }, field.Label)));
        }
        if (field.Type === "checkbox") {
          return /*#__PURE__*/React.createElement("div", {
            key: "key-".concat(field.Name),
            className: "location-detail-form__row"
          }, /*#__PURE__*/React.createElement(CheckBox, {
            name: field.Name,
            checked: field.Value,
            id: "checkbox-".concat(field.Name),
            label: field.Label,
            className: "location-detail-form__input location-detail-form__input--checkbox ".concat(formikProps.errors[field.Name] ? "location-detail-form__input--checkbox--error" : "")
          }), /*#__PURE__*/React.createElement("div", {
            className: "location-detail-form__field-info"
          }, /*#__PURE__*/React.createElement(ErrorMessage, {
            name: field.Name,
            component: "div",
            className: "location-detail-form__error location-detail-form__error--checkbox"
          })));
        }
        return /*#__PURE__*/React.createElement("div", {
          key: "key-".concat(field.Name),
          className: "location-detail-form__row ".concat(field.Name, "__row")
        }, /*#__PURE__*/React.createElement(Field, {
          type: field.Type,
          name: field.Name,
          id: field.Name,
          "aria-labelledby": "single-line-label-".concat(field.Name),
          tabIndex: field.Name === "location-info-issue" ? "-1" : "",
          onFocus: function onFocus() {
            handleFocusSingleLine(field.Name);
          },
          className: "location-detail-form__input location-detail-form__singleline ".concat(formikProps.errors[field.Name] ? "location-detail-form__singleline--error" : "")
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: field.Name,
          className: "location-detail-form__label",
          id: "single-line-label-".concat(field.Name)
        }, field.Placeholder), /*#__PURE__*/React.createElement("div", {
          className: "location-detail-form__field-info"
        }, field.Label && /*#__PURE__*/React.createElement("div", {
          id: "info-".concat(field.Name)
        }, field.Label), /*#__PURE__*/React.createElement(ErrorMessage, {
          name: field.Name,
          component: "div",
          className: "location-detail-form__error"
        })));
      }), /*#__PURE__*/React.createElement("div", {
        id: "captcha-container",
        className: "".concat(captchaRequiredError ? "error-border" : "")
      }), /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "button-magenta-full ".concat(isFormDisabled(formikProps) ? "disabled-class" : "")
      }, props.SubmitLabel));
    }
  }));
};
var EmbedForm = /*#__PURE__*/function (_React$Component) {
  function EmbedForm(props) {
    var _this;
    _classCallCheck(this, EmbedForm);
    _this = _callSuper(this, EmbedForm, [props]);
    _this.state = {
      embedHtml: "",
      element: ".grid-12 > .hcl-embed-form .clickdform"
    };
    return _this;
  }
  _inherits(EmbedForm, _React$Component);
  return _createClass(EmbedForm, [{
    key: "runEmbedFormDecorator",
    value: function runEmbedFormDecorator() {
      var form = document.querySelector(this.state.element);
      if (form && !form.classList.contains("inited")) {
        window.clickDimensionExternalForm ? setTimeout(function () {
          return window.clickDimensionExternalForm.init();
        }, 350) : null;
      }
    }
  }, {
    key: "hideLabels",
    value: function hideLabels() {
      document.querySelectorAll('.hcl-embed-form input[value="clinicDetails"], .hcl-embed-form input[value="clinicEmail"]').forEach(function (element) {
        return element.parentElement.parentElement.parentElement.style.display = "none";
      });
    }
  }, {
    key: "preFilledForm",
    value: function preFilledForm() {
      var emailInput = document.querySelector('.location-detail-form input[value="clinicEmail"]');
      var clinicInput = document.querySelector('.location-detail-form input[value="clinicDetails"]');
      if (emailInput && clinicInput) {
        emailInput.value = this.props.clinicEmail;
        clinicInput.value = this.props.clinicDetails;
      }
    }
  }, {
    key: "getHtmlEmbedForm",
    value: function getHtmlEmbedForm() {
      var form = document.querySelector(this.state.element);
      return form === null || form === void 0 ? void 0 : form.outerHTML;
    }
  }, {
    key: "checkIsFormLoaded",
    value: function checkIsFormLoaded() {
      return document.querySelector(this.state.element) ? true : false;
    }
  }, {
    key: "componentWillMount",
    value: function componentWillMount() {
      var _this2 = this;
      this.setState({
        embedHtml: this.getHtmlEmbedForm()
      });
      if (!this.checkIsFormLoaded()) {
        var waitingForEmbedForm = setInterval(function () {
          if (_this2.checkIsFormLoaded()) {
            _this2.setState({
              embedHtml: _this2.getHtmlEmbedForm()
            });
            _this2.runEmbedFormDecorator();
            clearInterval(waitingForEmbedForm);
          }
        }, 500);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.setState({
        embedHtml: ""
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.runEmbedFormDecorator();
      this.preFilledForm();
      this.hideLabels();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, this.state.embedHtml && /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: this.state.embedHtml
        }
      }));
    }
  }]);
}(React.Component);
OticonLocationDetailForm.propTypes = _defineProperty(_defineProperty({
  Fields: PropTypes.arrayOf(defaultPropTypes.formField).isRequired,
  FormTitle: PropTypes.string.isRequired,
  SubmitLabel: PropTypes.string.isRequired,
  SubmitEndPoint: PropTypes.string.isRequired,
  configurationId: PropTypes.string.isRequired,
  onFormSubmitSuccess: defaultPropTypes.func,
  onFormSubmitError: defaultPropTypes.func,
  onFormWillSubmit: defaultPropTypes.func,
  clinicDetails: PropTypes.string,
  clinicShortName: PropTypes.string,
  clinicEmail: PropTypes.string,
  clinicAddress: PropTypes.string,
  clinicCityAndPostCode: PropTypes.string
}, "clinicEmail", PropTypes.string), "clinicName", PropTypes.string);
OticonLocationDetailForm.defaultProps = {
  onFormSubmitSuccess: function onFormSubmitSuccess() {
    return null;
  },
  onFormSubmitError: function onFormSubmitError() {
    return null;
  },
  onFormWillSubmit: function onFormWillSubmit() {
    return null;
  },
  clinicDetails: "",
  clinicShortName: "",
  clinicEmail: "",
  clinicName: "",
  clinicCityAndPostCode: "",
  clinicPhone: ""
};
export default OticonLocationDetailForm;